/**
 * @param {string} accessToken
 * @returns {AxiosRequestConfig.headers} headers
 */
export function getHeaders(accessToken) {
  return { Authorization: `Bearer ${accessToken}` };
}
